import { all, call, put, select, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { BASE_URL } from "../../shared/constants";
import { addPlaceStart, addPlaceSuccess, addPlaceError } from "./reducer";

function* addPlace({ payload }) {
  try {
    const { token } = yield select((state) => state.auth);
    yield axios.post(`${BASE_URL}/landmark/addNewPlace`, payload.place, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    yield put(addPlaceSuccess());
  } catch (error) {
    yield put(
      addPlaceError({
        error,
      })
    );
  }
}

function* onAddPlace() {
  yield takeLatest(addPlaceStart.type, addPlace);
}

function* placeSagas() {
  yield all([call(onAddPlace)]);
}

export default placeSagas;
